/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable, DataTableRowToggleEvent } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";
import { Calendar } from "primereact/calendar";
import { InputText } from "primereact/inputtext";
import { useContext, useEffect, useRef, useState } from "react";
import {
  accordianHeaderTemplate,
  appTimeBodyTemplate,
  appTimeLogBodyTemplate,
  dateBodyTemplate,
  descriptionBodyTemplate,
  managerTimeListingBodyTemplate,
  projectNameBodyTemplate,
  statusBodyTemplate,
  tableHeaderTemplate,
  trackerTimeBodyTemplate,
  trackerTimeBodyTemplateViewOnly,
  vehicleRegistrationTemplate,
} from "../../common/TimeLogTemplates-teamlogs";
import {
  addTrackerTime,
  approveTimeLog,
  approveTimelogByHR,
  fetchProjects,
  fetchTeamLogsData,
  rejectTimeLog,
  updateProject,
  updateVehicle,
} from "./fetchData";
import { Toast } from "primereact/toast";
import { TLFilterContext } from "../TL_FiltersContext";
import { ProgressSpinner } from "primereact/progressspinner";
import { computeGroupedTimes } from "../../../../../helper/DateConverters";
import { TIMELOG_STATUSES } from "../../../../../util/constants";
import { Card } from "primereact/card";
import { Timeline } from "primereact/timeline";
import { Tooltip } from "primereact/tooltip";
import { RadioButton } from "primereact/radiobutton";

const TeamLogs = (props: any) => {
  const toast = useRef<Toast>(null);

  const context = useContext(TLFilterContext);
  if (!context) {
    throw new Error("FilterPage must be used within a FilterProvider");
  }

  const { filters } = context;

  const [teamLogsDataLoading, setTeamLogsDataLoading] =
    useState<boolean>(false);
  const [projectListLoading, setProjectListLoading] = useState<boolean>(false);

  const [teamLogsData, setTeamLogsData] = useState<any>([]);
  const [adminComments, setAdminComments] = useState<string>("");
  const [managerComments, setManagerComments] = useState<string>("");
  // const [hrComments, setHrComments] = useState<string>("");
  const [editTrackerTimeRowIndex, setEditTrackerTimeRowIndex] = useState<
    number | null
  >(null);
  const [editVehicleRowIndex, setEditVehicleRowIndex] = useState<any>(null);
  // const [sortFilter, props.setSortFilter] = useState<any>({
  //   sortField: "registration_no",
  //   sortOrder: true,
  // });
  const [expandedRows, setExpandedRows] = useState<any>([]);

  const [timeLogDetails, setTimeLogDetails] = useState<any>([]);
  const [isSaveButtonDisabled, setIsSaveButtonDisabled] =
    useState<boolean>(true);

  const [isHRApproving, setIsHRApproving] = useState<boolean>(false);
  const [time, setTime] = useState<Date | null>(null);
  const [showTimeLogDetails, setShowTimeLogDetails] = useState<boolean>(false);
  const [visible, setVisible] = useState<boolean>(false);
  const [viewHistoryPopup, setViewHistoryPopup] = useState<boolean>(false);
  const [isManagerApproveView, setIsManagerApproveView] =
    useState<boolean>(false);
  const [editProjectIndices, setEditProjectIndices] = useState<any>([]);
  const [projectsList, setProjectsList] = useState<any>([]);
  const [selectedProjectArray, setSelectedProjectArray] = useState<any>([]);
  const [selectedAppTimeDataArray, setSelectedAppTimeDataArray] = useState<any>(
    []
  );
  const [selectedProject, setSelectedProject] = useState<any>(null);
  const [selectedVehicle, setSelectedVehicle] = useState<any>(null);
  const [selectedVehicleRegistrationNo, setSelectedVehicleRegistrationNo] =
    useState<string>("");
  const [selectedRowData, setSelectedRowData] = useState<any>(null);
  const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(false);
  const [addTrackerTimeData, setAddTrackerTimeData] = useState<any>({
    timeLogID: null,
    tracker_start: null,
    tracker_end: null,
    tracker_duration: null,
    admin_comment: null,
    isLogTimeMisMatch: false,
  });

  const [managerTimeData, setManagerTimeData] = useState<any>({
    manager_start: null,
    manager_end: null,
    manager_duration: null,
  });

  const [timelogActivity, setTimelogActivity] = useState<any>([]);

  const [hideAdminComments, setHideAdminComments] = useState<boolean>(false);
  const [hideManagerComments, setHideManagerComments] =
    useState<boolean>(false);

  const [editAppTimeRowIndices, setEditAppTimeRowIndices] = useState<any>([]);

  const [isManagerRejectView, setIsManagerRejectView] =
    useState<boolean>(false);
  const [showApprovePopup, setShowApprovePopup] = useState<boolean>(false);
  const [selectedApproveTimeType, setSelectedApproveTimeType] =
    useState<string>("app_time");
  const [showRejectPopup, setShowRejectPopup] = useState<boolean>(false);
  const [hrComment, setHrComment] = useState<string>("");

  // Function to calculate duration for manager time
  const calculateManagerDuration = (
    startTimeEpoch: number,
    endTimeEpoch: number
  ) => {
    if (!startTimeEpoch || !endTimeEpoch) return "00:00";
    const startTime = new Date(startTimeEpoch * 1000);
    const endTime = new Date(endTimeEpoch * 1000);

    let timeDifferenceMs = endTime.getTime() - startTime.getTime();
    if (timeDifferenceMs < 0) {
      timeDifferenceMs += 24 * 60 * 60 * 1000; // Add 24 hours in milliseconds
    }
    const totalSeconds = Math.floor(timeDifferenceMs / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);

    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0"
    )}`;
  };

  useEffect(() => {
    if (props.isWorkerView) {
      props.setSortFilter({ sortField: "displayName", sortOrder: true });
    } else {
      props.setSortFilter({ sortField: "registration_no", sortOrder: true });
    }
  }, [props.isWorkerView]);

  useEffect(() => {
    fetchProjects(setProjectsList, setProjectListLoading, toast);
    setExpandedRows([]);
  }, []);

  useEffect(() => {
    const updateAndFetchData = async () => {
      if (selectedVehicle) {
        await updateVehicle(
          selectedVehicle,
          toast,
          setTeamLogsDataLoading,
          setEditVehicleRowIndex
        );
        fetchTeamLogsData({
          sortFilter: props.sortFilter,
          setTeamLogsData,
          setTeamLogsDataLoading,
          filters: filters.endDate && filters,
          toast: toast,
          isWorkerView: props.isWorkerView,
          setExpandedRows,
          setIsExportDisabled: props.setIsExportDisabled,
        });
        setHideAdminComments(false);
        setHideManagerComments(false);
      }
    };
    updateAndFetchData();
  }, [selectedVehicle]);

  useEffect(() => {
    if (filters?.startDate && filters?.endDate) {
      fetchTeamLogsData({
        sortFilter: props.sortFilter,
        setTeamLogsData,
        setTeamLogsDataLoading,
        filters: filters.endDate && filters,
        toast: toast,
        isWorkerView: props.isWorkerView,
        setExpandedRows,
        setIsExportDisabled: props.setIsExportDisabled,
        // setHideAdminComments,
        // setHideManagerComments,
      });
    }
  }, [props.sortFilter, filters]);

  useEffect(() => {
    if (
      selectedAppTimeDataArray.length !== 0 ||
      selectedProjectArray.length !== 0
    ) {
      setIsSaveButtonDisabled(false);
    }
  }, [selectedAppTimeDataArray.length, selectedProjectArray.length]);

  // Custom error template (can also include icons or custom components)
  const emptyMessageTemplate = (
    <div style={{ textAlign: "center", fontSize: "1.25rem" }}>
      <h4>No records found.</h4>
    </div>
  );

  const actionBodyTemplate = (rowData: any) => {
    const isEdit = editProjectIndices.includes(rowData.timelogdetailsID);
    const isAppTimeEdit = editAppTimeRowIndices.includes(
      rowData.timelogdetailsID
    );

    const handleEditClick = (timelogdetailsID: any) => {
      if (isEdit) {
        setEditProjectIndices(
          editProjectIndices.filter((index: any) => index !== timelogdetailsID)
        );
      } else {
        setEditProjectIndices([...editProjectIndices, timelogdetailsID]);
      }

      if (isManagerRejectView) {
        if (isAppTimeEdit) {
          setEditAppTimeRowIndices(
            editAppTimeRowIndices.filter(
              (index: any) => index !== timelogdetailsID
            )
          );
        } else {
          setEditAppTimeRowIndices([
            ...editAppTimeRowIndices,
            timelogdetailsID,
          ]);
        }
      }
    };

    return (
      <Button
        icon={
          isEdit || (isManagerRejectView && isAppTimeEdit)
            ? "pi pi-times"
            : "pi pi-pencil"
        }
        className="tw-bg-white tw-border-0 tw-border-solid tw-border-transparent tw-px-1 focus:tw-shadow-none"
        onClick={() => {
          if (
            rowData.lineManagerID.toString() ===
              localStorage.userID.toString() &&
            rowData.status === TIMELOG_STATUSES.SUBMITTED_TO_MANAGER
          ) {
            if (rowData.status === TIMELOG_STATUSES.APPROVED) {
              return;
            } else {
              handleEditClick(rowData.timelogdetailsID);
              if (isEdit || (isManagerRejectView && isAppTimeEdit)) {
                setIsSaveButtonDisabled(true);
              } else if (
                selectedProjectArray.length !== 0 ||
                selectedAppTimeDataArray.length !== 0
              ) {
                setIsSaveButtonDisabled(false);
              }
            }
          } else return;
        }}
      />
    );
  };

  const handleAddAdminComments = (rowData: any) => {
    if (adminComments.trim() === "") {
      setVisible(false);
      return;
    } else {
      addTrackerTime(
        addTrackerTimeData,
        rowData.timeLogID,
        toast,
        setTeamLogsDataLoading,
        setEditTrackerTimeRowIndex,
        rowData,
        hideAdminComments,
        hideManagerComments,
        "addAdminComment"
      ).then(() => {
        fetchTeamLogsData({
          sortFilter: props.sortFilter,
          setTeamLogsData: setTeamLogsData,
          setTeamLogsDataLoading: setTeamLogsDataLoading,
          filters: filters.endDate && filters,
          toast: toast,
          isWorkerView: props.isWorkerView,
          setExpandedRows,
          setIsExportDisabled: props.setIsExportDisabled,
        });
        setHideAdminComments(false);
        setHideManagerComments(false);
        setVisible(false);
        setAdminComments("");
      });
    }
  };

  const handleRejectTimeLog = (rowData: any) => {
    // if (selectedAppTimeDataArray.length !== 0) {
    rejectTimeLog(
      selectedRowData,
      selectedProjectArray,
      selectedAppTimeDataArray,
      managerTimeData,
      toast,
      managerComments,
      setTeamLogsDataLoading,
      hideManagerComments
    ).then(() => {
      fetchTeamLogsData({
        sortFilter: props.sortFilter,
        setTeamLogsData: setTeamLogsData,
        setTeamLogsDataLoading: setTeamLogsDataLoading,
        filters: filters.endDate && filters,
        toast: toast,
        isWorkerView: props.isWorkerView,
        setExpandedRows,
        setIsExportDisabled: props.setIsExportDisabled,
      });
      setShowTimeLogDetails(false);
      setIsManagerRejectView(false);
      setHideAdminComments(false);
      setHideManagerComments(false);
      setManagerComments("");
    });
    // } else {
    //   setHideAdminComments(false);
    //   setHideManagerComments(false);
    //   showError(
    //     "Please modify app time according to tracker time to reject the timelog.",
    //     toast
    //   );
    // }
  };

  const handleUpdateProject = (e: any) => {
    if (selectedProjectArray.length === 0) {
      return;
    } else {
      updateProject(
        selectedRowData,
        selectedProjectArray,
        toast,
        setTeamLogsDataLoading,
        setEditProjectIndices
      ).then(() => {
        fetchTeamLogsData({
          sortFilter: props.sortFilter,
          setTeamLogsData: setTeamLogsData,
          setTeamLogsDataLoading: setTeamLogsDataLoading,
          filters: filters.endDate && filters,
          toast: toast,
          isWorkerView: props.isWorkerView,
          setExpandedRows,
          setIsExportDisabled: props.setIsExportDisabled,
        });
        setHideAdminComments(false);
        setHideManagerComments(false);
        setShowTimeLogDetails(false);
        setEditProjectIndices([]);
      });
    }
  };

  const handleApproveTimeLog = (rowData: any) => {
    approveTimeLog(
      rowData.timeLogID,
      managerComments,
      hideManagerComments,
      toast,
      setTeamLogsDataLoading
    ).then(() => {
      fetchTeamLogsData({
        sortFilter: props.sortFilter,
        setTeamLogsData: setTeamLogsData,
        setTeamLogsDataLoading: setTeamLogsDataLoading,
        filters: filters.endDate && filters,
        toast: toast,
        isWorkerView: props.isWorkerView,
        setExpandedRows,
        setIsExportDisabled: props.setIsExportDisabled,
      });
      setHideAdminComments(false);
      setHideManagerComments(false);
      setIsManagerApproveView(false);
      setManagerComments("");
      setShowApprovePopup(false);
      setSelectedApproveTimeType("app_time");
    });
  };

  const formatCreatedDate = (dateString: string) => {
    const date = new Date(dateString);

    const day = date.getUTCDate().toString().padStart(2, "0"); // 25
    const month = date.toLocaleString("en-UK", { month: "short" }); // Sep
    const year = date.getUTCFullYear(); // 2024

    const time = date.toLocaleTimeString("en-UK", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    return `${day} ${month} ${year} ${time}`;
  };

  const events: any = timelogActivity?.map((activity: any) => {
    return {
      action: activity?.action,
      date: activity?.createdAt,
      actionTakerDisplayName: activity?.actionTakerDisplayName,
      comment: activity?.comment,
      isWeb: activity?.isWeb,
      lineManagerName: activity?.lineManagerName,
      lineManagerID: activity?.lineManagerID,
      roleName: activity?.roleName,
      status: activity?.status,
      timeLogID: activity?.timeLogID,
      userID: activity?.userID,
    };
  });

  // const events = ["sd", "as", "as"];

  const customizedMarker = () => {
    return (
      <>
        <div className="tw-flex tw-justify-center tw-items-center tw-w-5 tw-h-5 tw-rounded-full tw-bg-[#E2E8F0]">
          <div className="tw-w-3 tw-h-3 tw-rounded-full tw-bg-[#00AFEE]"></div>
        </div>
      </>
    );
  };

  const customizedContent = (item: any) => {
    // const bgColour =
    //   item?.action === "Time log added"
    //     ? "tw-bg-yellow-50"
    //     : item?.action === "Time Log Submitted"
    //     ? "tw-bg-blue-50"
    //     : item?.action === "Tracker time updated by Admin"
    //     ? "tw-bg-gray-50"
    //     : item?.action === "Timelog submitted to manager"
    //     ? "tw-bg-[#25ccdb]"
    //     : item?.action === "Timelog APPROVED BY MANAGER by Manager"
    //     ? "tw-bg-brown-50"
    //     : item?.action === "Timelog approved by HR"
    //     ? "tw-bg-[#f5fff8]"
    //     : // : item?.action === "Timelog submitted to manager"
    //       // ? "tw-bg-[#25ccdb]"
    //       "tw-bg-red-50";

    return (
      <>
        {item?.action ? (
          <Card className={`activity-card tw-bg-gray-50`}>
            <div className="activity-container tw-flex tw-justify-between tw-items-center tw-mb-4">
              {/* <span className="po-number tw-text-ellipsis tw-overflow-hidden tw-max-w-52">
            {item?.status}
          </span> */}
              <span className="activity-date tw-text-ellipsis tw-overflow-hidden tw-max-w-52">
                {formatCreatedDate(item?.date)}
              </span>
            </div>
            <span className="activity-content tw-text-ellipsis tw-overflow-hidden tw-max-w-52">
              {item?.action ? (
                item?.action === "Tracker time updated by admin" ||
                item?.action === "Comment added by admin" ||
                item?.action === "Comment added by HR" ||
                item?.action === "Vehicle updated by manager" ||
                item?.action === "Project updated by manager" ||
                item?.action === "Timelog approved by manager" ||
                item?.action === "Timelog unlocked by Admin" ||
                item?.action === "Timelog locked by Admin" ||
                item?.action === "Timelog approved by HR" ||
                item?.action === "Timelog rejected by HR" ||
                item?.action === "Timelog rejected by manager" ||
                item?.action === "Timelog approved by HR" ? (
                  <span>
                    <span className="tw-font-medium tw-text-gray-700">
                      {item?.action}
                    </span>{" "}
                    <span className="tw-text-gray-600">
                      {item.actionTakerDisplayName ?? "N/A"}
                    </span>
                  </span>
                ) : (
                  // `${item?.action} by ${item?.actionTakerDisplayName}`
                  <span>
                    <span className="tw-font-medium tw-text-gray-700">
                      {item?.action}
                    </span>{" "}
                    <span className="tw-text-gray-600">
                      by{" "}
                      {item.actionTakerDisplayName
                        ? item.actionTakerDisplayName
                        : item?.action ===
                          "Timelog was auto-locked and sent to HR for adding tracker time and approval"
                        ? "System"
                        : "N/A"}
                    </span>
                  </span>
                )
              ) : (
                ""
              )}
            </span>
            <div className="tw-flex tw-justify-between tw-items-center tw-mt-1 tw-font-medium tw-text-[#6611119c]">
              <span className="tw-ml-auto">{item?.comment}</span>
            </div>
          </Card>
        ) : (
          <>
            <div>No History Found</div>
          </>
        )}
      </>
    );
  };

  const groupedTimes = computeGroupedTimes(
    teamLogsData,
    props.isWorkerView ? "displayName" : "registration_no"
  );

  //  const handleExportTimelog = async () => {
  //   setIsExporting(true);
  //   const newDates: any = {};
  //   newDates.startDate = convertEpochtoDate(filters.startDate);
  //   newDates.endDate = convertEpochtoDate(filters.endDate);
  //   try {
  //     const response = await axios.get(`tl-user/export-time-sheet`);
  //     const url = "";
  //     const link = document.createElement("a");
  //     link.href = url;
  //     link.setAttribute(
  //       "download",
  //       `timelog_export_${newDates.startDate}_${newDates.endDate}.xlsx`
  //     );
  //     document.body.appendChild(link);
  //     link.click();
  //     showSuccess(`Timelog exported successfully.`, toast);
  //   } catch (err: unknown) {
  //     const error = getErrorMessage(err);
  //     showError(error, toast);
  //   } finally {
  //     setIsExporting(false);
  //   }
  // };

  // const handleExportTimelog = async () => {
  //   setIsExporting(true);
  //   try {
  //     // Prepare the query parameters from filters
  //     const params: any = {
  //       sortField: `${
  //         props.isWorkerView ? "displayName" : "registration_no"
  //       } , ${props.sortFilter.sortField}`,
  //       sortOrder:
  //         props.sortFilter.sortOrder === true
  //           ? SORT_FILTER.ASC
  //           : SORT_FILTER.DESC,
  //     };

  //     if (filters) {
  //       params.startDate = filters.startDate;
  //       params.endDate = filters.endDate;
  //       params.vehicleID = filters?.vehicleRegistration?.vehicleID;
  //       filters.name !== "" && (params.displayName = filters.name);
  //       filters.status && (params.status = filters.status);
  //     }
  //     // const response = await axios.get("tl-user/team-logs-list", { params });

  //     // Add view type
  //     // params.append('isWorkerView', isWorkerView.toString());

  //     const response = await axios.get(`tl-user/export-time-sheet`, params);

  //     // Handle the response (assuming it's a blob for file download)
  //     // const url = window.URL.createObjectURL(new Blob([response.data]));
  //     const url = "";
  //     const link = document.createElement("a");
  //     link.href = url;
  //     link.setAttribute(
  //       "download",
  //       `timelog_export_${
  //         filters.startDate ? convertEpochtoDate(filters.startDate) : ""
  //       }_${filters.endDate ? convertEpochtoDate(filters.endDate) : ""}.xlsx`
  //     );
  //     document.body.appendChild(link);
  //     link.click();
  //     showSuccess(`Timelog exported successfully.`, toast);
  //   } catch (err: unknown) {
  //     const error = getErrorMessage(err);
  //     showError(error, toast);
  //   } finally {
  //     setIsExporting(false);
  //   }
  // };

  return (
    <>
      <Toast ref={toast} />
      <div className="">
        {teamLogsDataLoading ? (
          <div className="tw-h-full tw-w-full tw-bg-transparent tw-flex tw-justify-center tw-items-center tw-absolute tw-top-0 tw-left-0 tw-z-50">
            <ProgressSpinner />
          </div>
        ) : (
          <div className="card">
            {isHRApproving && (
              <div className="tw-h-full tw-w-full tw-bg-transparent tw-flex tw-justify-center tw-items-center tw-absolute tw-top-0 tw-left-0 tw-z-50">
                <ProgressSpinner />
              </div>
            )}
            <DataTable
              value={teamLogsData}
              rowGroupMode="subheader"
              groupRowsBy={
                props.isWorkerView ? "displayName" : "registration_no"
              }
              expandableRowGroups
              expandedRows={expandedRows}
              emptyMessage={emptyMessageTemplate}
              onRowToggle={(e: DataTableRowToggleEvent) => {
                setExpandedRows(e.data);
              }}
              rowGroupHeaderTemplate={(e) =>
                accordianHeaderTemplate(e, props.isWorkerView, groupedTimes)
              }
              tableStyle={{ minWidth: "50rem" }}
              className="a-table timelog-datatable tw-text-nowrap tw-text-sm tw-text-[#64748B]"
              rowClassName={(rowData: any) =>
                rowData.isLogTimeMisMatch === 1 ? "error-row" : ""
              }
            >
              <Column
                field="date"
                header={tableHeaderTemplate(
                  "Date",
                  "log_date",
                  props.setSortFilter
                )}
                body={dateBodyTemplate}
              ></Column>
              {/* <Column field="projectName" header="Project Name" sortable></Column> */}
              {props.isWorkerView ? (
                <Column
                  field="registration_no"
                  header={tableHeaderTemplate(
                    "Vehicle Registration",
                    "registration_no",
                    props.setSortFilter
                  )}
                  body={(e) =>
                    vehicleRegistrationTemplate(
                      e,
                      props.vehiclesList,
                      props.vehicleListLoading,
                      editVehicleRowIndex,
                      setEditVehicleRowIndex,
                      selectedVehicle,
                      setSelectedVehicle,
                      selectedVehicleRegistrationNo,
                      setSelectedVehicleRegistrationNo
                    )
                  }
                ></Column>
              ) : (
                <Column
                  field="displayName"
                  header={tableHeaderTemplate(
                    "Person Name",
                    "displayName",
                    props.setSortFilter
                  )}
                ></Column>
              )}
              <Column
                field="projectKeys"
                header={tableHeaderTemplate(
                  "Projects",
                  "",
                  props.setSortFilter
                )}
                body={(e) => {
                  const projectDetails = e?.timelogdetails
                    ?.filter((detail: any) => detail?.projectName)
                    .map((detail: any) => ({
                      key: detail.projectKey,
                      name: detail.projectName,
                      time: detail.duration,
                      description: detail.description,
                    }));

                  return (
                    <div className="tw-flex tw-flex-col tw-gap-2">
                      {projectDetails?.map((project: any, index: number) => (
                        <div
                          key={index}
                          className="tw-text-sm tw-text-[#64748B]"
                        >
                          <Tooltip
                            target=".out-project-desc"
                            mouseTrack
                            mouseTrackLeft={10}
                            position="bottom"
                            className="tw-max-w-sm tw-text-sm"
                          />
                          <div className="tw-font-medium">{`${project.name} - (${project.key})`}</div>
                          <div className="tw-text-xs">
                            {project.time && <span>Time: {project.time}</span>}
                            {project.description && (
                              <span
                                className="tw-ml-2 out-project-desc"
                                data-pr-tooltip={
                                  project.description.length > 50
                                    ? project.description
                                    : undefined
                                }
                              >
                                -{" "}
                                {project.description.length > 50
                                  ? `${project.description.substring(
                                      0,
                                      50
                                    )}.....`
                                  : project.description}
                              </span>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  );
                }}
              ></Column>
              <Column
                field="appTime"
                header={tableHeaderTemplate(
                  "Claimed Time",
                  "duration",
                  props.setSortFilter
                )}
                body={(e) =>
                  appTimeBodyTemplate(
                    e,
                    setShowTimeLogDetails,
                    setTimeLogDetails
                  )
                }
              ></Column>
              <Column
                field="managerTime"
                header={tableHeaderTemplate(
                  "Manager Time",
                  "manager_duration",
                  props.setSortFilter
                )}
                body={(e) =>
                  managerTimeListingBodyTemplate(
                    e
                    // setShowTimeLogDetails,
                    // setTimeLogDetails
                  )
                }
              ></Column>
              <Column
                field="trackerTime"
                header={tableHeaderTemplate(
                  "Tracker Time",
                  "tracker_duration",
                  props.setSortFilter
                )}
                body={(e) =>
                  trackerTimeBodyTemplate({
                    rowData: e,
                    time,
                    setTime,
                    setVisible,
                    setViewHistoryPopup,
                    editTrackerTimeRowIndex,
                    setEditTrackerTimeRowIndex,
                    addTrackerTimeData,
                    setAddTrackerTimeData,
                    toast,
                    setTeamLogsDataLoading,
                    sortFilter: props.sortFilter,
                    setTeamLogsData,
                    filters,
                    selectedRowData,
                    setSelectedRowData,
                    setExpandedRows,
                    isWorkerView: props.isWorkerView,
                    setIsExportDisabled: props.setIsExportDisabled,
                    setTimelogActivity: setTimelogActivity,
                    type: "teamLogs",
                  })
                }
              ></Column>
              <Column
                field="status"
                header={tableHeaderTemplate(
                  "Status",
                  "status",
                  props.setSortFilter
                )}
                body={(e) =>
                  statusBodyTemplate(
                    e,
                    setShowTimeLogDetails,
                    setTimeLogDetails,
                    setIsManagerRejectView,
                    setIsManagerApproveView,
                    setSelectedRowData,
                    props.sortFilter,
                    setTeamLogsData,
                    setTeamLogsDataLoading,
                    filters.endDate && filters,
                    props.isWorkerView,
                    setExpandedRows,
                    props.setIsExportDisabled,
                    setIsHRApproving,
                    toast,
                    setShowApprovePopup,
                    setShowRejectPopup
                  )
                }
              ></Column>
            </DataTable>

            <Dialog
              className="comments-dialog tw-w-[444px]"
              style={{ maxWidth: "620px" }}
              header={`Comments (${selectedRowData?.displayName || ""})`}
              visible={visible}
              draggable={false}
              onHide={() => {
                if (!visible) return;
                setVisible(false);
                setAdminComments("");
                setIsButtonDisabled(false);
              }}
            >
              <div className="tw-p-6">
                <div className="tw-py-6 tw-flex tw-flex-col tw-gap-2 tw-w-full">
                  {selectedRowData?.admin_comment && (
                    <div className="tw-p-4 tw-border-b tw-border-b-solid tw-border-b-[#DBDBDB]">
                      <p className="tw-m-0 tw-text-sm tw-font-medium tw-text-[#64748B] tw-mb-2">
                        Super Admin Notes
                      </p>
                      <p className="tw-m-0 tw-text-base tw-font-medium tw-text-black tw-break-words">
                        {selectedRowData?.admin_comment}
                      </p>
                    </div>
                  )}
                  {selectedRowData?.manager_comment && (
                    <div className="tw-p-4 tw-border-b tw-border-b-solid tw-border-b-[#DBDBDB]">
                      <p className="tw-m-0 tw-text-sm tw-font-medium tw-text-[#64748B] tw-mb-2">
                        Manager Notes
                      </p>
                      <p className="tw-m-0 tw-text-base tw-font-medium tw-text-black tw-break-words">
                        {selectedRowData?.manager_comment}
                      </p>
                    </div>
                  )}
                  {selectedRowData?.hr_comment && (
                    <div className="tw-p-4 tw-border-b tw-border-b-solid tw-border-b-[#DBDBDB]">
                      <p className="tw-m-0 tw-text-sm tw-font-medium tw-text-[#64748B] tw-mb-2">
                        HR Notes
                      </p>
                      <p className="tw-m-0 tw-text-base tw-font-medium tw-text-black tw-break-words">
                        {selectedRowData?.hr_comment}
                      </p>
                    </div>
                  )}
                </div>
                {!(
                  isButtonDisabled ||
                  selectedRowData?.status === TIMELOG_STATUSES.APPROVED ||
                  selectedRowData?.status === TIMELOG_STATUSES.REJECTED
                ) && (
                  <>
                    <InputTextarea
                      value={adminComments}
                      onChange={(e) => {
                        setAddTrackerTimeData((prev: any) => ({
                          ...prev,
                          admin_comment: e.target.value,
                        }));
                        setAdminComments(e.target.value);
                      }}
                      rows={5}
                      cols={30}
                      placeholder="Add Comment"
                    />
                    <div className="tw-flex tw-items-center tw-mt-6 tw-text-base">
                      <input
                        type="checkbox"
                        id="hideComment"
                        className="tw-mr-2 tw-cursor-pointer tw-w-5 tw-h-4"
                        onChange={(e) => {
                          setHideAdminComments(e.target.checked);
                        }}
                        disabled={
                          isButtonDisabled ||
                          selectedRowData?.status === TIMELOG_STATUSES.APPROVED
                        }
                      />
                      <label
                        htmlFor="hideComment"
                        className="tw-text-base tw-cursor-pointer tw-text-gray-700"
                      >
                        Hide comment from the user
                      </label>
                    </div>
                  </>
                )}
              </div>
              {!(
                isButtonDisabled ||
                selectedRowData?.status === TIMELOG_STATUSES.APPROVED ||
                selectedRowData?.status === TIMELOG_STATUSES.REJECTED
              ) && (
                <div className="tw-flex tw-w-full tw-gap-2 tw-pt-6 tw-px-6 tw-pb-6 tw-border-t tw-border-t-solid tw-border-t-[#DBDBDB]">
                  <Button
                    label="Submit"
                    onClick={() => handleAddAdminComments(selectedRowData)}
                    disabled={
                      isButtonDisabled ||
                      selectedRowData?.status === TIMELOG_STATUSES.APPROVED
                    }
                    className="tw-w-full tw-py-3 tw-bg-[#00AFEE] tw-text-white tw-rounded-lg tw-font-semibold"
                  />
                </div>
              )}
            </Dialog>

            <Dialog
              className="comments-dialog tw-w-[444px]"
              style={{ maxWidth: "620px" }}
              header={`Timelog History (${selectedRowData?.displayName || ""})`}
              visible={viewHistoryPopup}
              draggable={false}
              onHide={() => {
                if (!viewHistoryPopup) return;
                setViewHistoryPopup(false);
                setHideAdminComments(false);
                // setTimelogActivity([]);
                setHideManagerComments(false);
              }}
            >
              <>
                {timelogActivity && timelogActivity.length !== 0 ? (
                  <Timeline
                    className="tw-p-4"
                    align="left"
                    marker={customizedMarker}
                    content={customizedContent}
                    value={events}
                  />
                ) : (
                  <div className="tw-p-4 tw-border-b tw-text-center tw-border-b-solid tw-border-b-[#DBDBDB]">
                    <p className="tw-m-0 tw-text-sm tw-font-medium tw-text-[#64748B] tw-mb-2">
                      No History Found
                    </p>
                  </div>
                )}
              </>
            </Dialog>

            <Dialog
              className="comments-dialog"
              header={`Approve Time Log (${
                selectedRowData?.displayName || ""
              })`}
              visible={isManagerApproveView}
              draggable={false}
              style={{ maxWidth: "400px" }}
              onHide={() => {
                if (!isManagerApproveView) return;
                setIsManagerApproveView(false);
                setManagerComments("");
                setIsButtonDisabled(false);
              }}
            >
              <div className="tw-p-6">
                <InputTextarea
                  value={managerComments}
                  onChange={(e) => {
                    // setAddTrackerTimeData((prev: any) => ({
                    //   ...prev,
                    //   admin_comment: e.target.value,
                    // }));
                    setManagerComments(e.target.value);
                  }}
                  rows={5}
                  cols={30}
                  placeholder="Add Comment"
                />
                <div className="tw-flex tw-items-center tw-mt-6 tw-text-base">
                  <input
                    type="checkbox"
                    id="hideComment"
                    className="tw-mr-2 tw-cursor-pointer tw-w-5 tw-h-4"
                    onChange={(e) => {
                      setHideManagerComments(e.target.checked);
                    }}
                    disabled={isButtonDisabled}
                  />
                  <label
                    htmlFor="hideComment"
                    className="tw-text-base tw-cursor-pointer tw-text-gray-700"
                  >
                    Hide comment from the user
                  </label>
                </div>
              </div>
              <div className="tw-flex tw-w-full tw-gap-2 tw-pt-6 tw-px-6 tw-pb-6 tw-border-t tw-border-t-solid tw-border-t-[#DBDBDB]">
                <Button
                  label="Submit"
                  onClick={() => handleApproveTimeLog(selectedRowData)}
                  disabled={isButtonDisabled}
                  className="tw-w-full tw-py-3 tw-bg-[#00AFEE] tw-text-white tw-rounded-lg tw-font-semibold"
                />
              </div>
            </Dialog>

            {/* HR Approve Timelog Popup */}
            <Dialog
              className="approve-timelog-dialog"
              style={{ maxWidth: "500px" }}
              header={`Approve Time Log (${
                selectedRowData?.displayName || ""
              })`}
              visible={showApprovePopup}
              draggable={false}
              onHide={() => {
                if (!showApprovePopup) return;
                setShowApprovePopup(false);
                setSelectedApproveTimeType("app_time");
                setHrComment("");
              }}
            >
              <div className="tw-p-6">
                {(selectedRowData?.status ===
                  TIMELOG_STATUSES.APPROVED_BY_MANAGER ||
                  selectedRowData?.status ===
                    TIMELOG_STATUSES.REJECTED_BY_MANAGER) && (
                  <div className="tw-mb-6">
                    <h4 className="tw-text-base tw-font-semibold tw-mb-4">
                      Select which time to approve:
                    </h4>
                    <div className="tw-flex tw-flex-col tw-gap-4">
                      <div className="tw-flex tw-items-center">
                        <RadioButton
                          inputId="app_time"
                          name="approveTimeType"
                          value="app_time"
                          onChange={(e) => setSelectedApproveTimeType(e.value)}
                          checked={selectedApproveTimeType === "app_time"}
                        />
                        <label
                          htmlFor="app_time"
                          className="tw-ml-2 tw-cursor-pointer"
                        >
                          Claimed Time
                        </label>
                      </div>
                      {selectedRowData?.manager_duration && (
                        <div className="tw-flex tw-items-center">
                          <RadioButton
                            inputId="manager_time"
                            name="approveTimeType"
                            value="manager_time"
                            onChange={(e) =>
                              setSelectedApproveTimeType(e.value)
                            }
                            checked={selectedApproveTimeType === "manager_time"}
                          />
                          <label
                            htmlFor="manager_time"
                            className="tw-ml-2 tw-cursor-pointer"
                          >
                            Manager Time
                          </label>
                        </div>
                      )}
                      <div className="tw-flex tw-items-center">
                        <RadioButton
                          inputId="tracker_time"
                          name="approveTimeType"
                          value="tracker_time"
                          onChange={(e) => setSelectedApproveTimeType(e.value)}
                          checked={selectedApproveTimeType === "tracker_time"}
                        />
                        <label
                          htmlFor="tracker_time"
                          className="tw-ml-2 tw-cursor-pointer"
                        >
                          Tracker Time
                        </label>
                      </div>
                    </div>
                  </div>
                )}
                <div className="tw-mb-6">
                  <h4 className="tw-text-base tw-font-semibold tw-mb-2">
                    HR Comment (Optional)
                  </h4>
                  <InputTextarea
                    value={hrComment}
                    onChange={(e) => setHrComment(e.target.value)}
                    rows={5}
                    cols={30}
                    placeholder="Add comment..."
                    className="tw-w-full"
                  />
                </div>
                <div className="tw-flex tw-w-full tw-gap-2 tw-pt-4 tw-border-t tw-border-t-solid tw-border-t-[#DBDBDB]">
                  <Button
                    label="Cancel"
                    onClick={() => {
                      setShowApprovePopup(false);
                      setSelectedApproveTimeType("app_time");
                      setHrComment("");
                    }}
                    className="tw-w-1/2 tw-py-3 tw-bg-white tw-border tw-border-gray-300 tw-text-gray-700 tw-rounded-lg tw-font-semibold"
                  />
                  <Button
                    label="Approve"
                    onClick={() => {
                      approveTimelogByHR(
                        selectedRowData.timeLogID,
                        selectedRowData?.status === TIMELOG_STATUSES.SUBMITTED
                          ? TIMELOG_STATUSES.SUBMITTED_TO_MANAGER
                          : TIMELOG_STATUSES.APPROVED,
                        setIsHRApproving,
                        toast,
                        selectedApproveTimeType,
                        hrComment
                      ).then(() => {
                        fetchTeamLogsData({
                          sortFilter: props.sortFilter,
                          setTeamLogsData,
                          setTeamLogsDataLoading,
                          filters: filters.endDate && filters,
                          toast,
                          isWorkerView: props.isWorkerView,
                          setExpandedRows,
                          setIsExportDisabled: props.setIsExportDisabled,
                        });
                        setShowApprovePopup(false);
                        setSelectedApproveTimeType("app_time");
                        setHrComment("");
                      });
                    }}
                    disabled={isHRApproving}
                    className="tw-w-1/2 tw-py-3 tw-bg-[#00AFEE] tw-text-white tw-rounded-lg tw-font-semibold"
                  />
                </div>
              </div>
            </Dialog>

            {/* HR Reject Timelog Popup */}
            <Dialog
              className="reject-timelog-dialog"
              style={{ maxWidth: "500px" }}
              header={`Reject Time Log (${selectedRowData?.displayName || ""})`}
              visible={showRejectPopup}
              draggable={false}
              onHide={() => {
                if (!showRejectPopup) return;
                setShowRejectPopup(false);
                setHrComment("");
              }}
            >
              <div className="tw-p-6">
                <div className="tw-mb-6">
                  <h4 className="tw-text-base tw-font-semibold tw-mb-2">
                    HR Comment <span className="tw-text-red-500">*</span>
                  </h4>
                  <InputTextarea
                    value={hrComment}
                    onChange={(e) => setHrComment(e.target.value)}
                    rows={5}
                    cols={30}
                    placeholder="Enter reason for rejection..."
                    className="tw-w-full"
                  />
                </div>
                <div className="tw-flex tw-w-full tw-gap-2 tw-pt-4 tw-border-t tw-border-t-solid tw-border-t-[#DBDBDB]">
                  <Button
                    label="Cancel"
                    onClick={() => {
                      setShowRejectPopup(false);
                      setHrComment("");
                    }}
                    className="tw-w-1/2 tw-py-3 tw-bg-white tw-border tw-border-gray-300 tw-text-gray-700 tw-rounded-lg tw-font-semibold"
                  />
                  <Button
                    label="Reject"
                    onClick={() => {
                      approveTimelogByHR(
                        selectedRowData.timeLogID,
                        "REJECTED",
                        setIsHRApproving,
                        toast,
                        undefined,
                        hrComment
                      ).then(() => {
                        fetchTeamLogsData({
                          sortFilter: props.sortFilter,
                          setTeamLogsData,
                          setTeamLogsDataLoading,
                          filters: filters.endDate && filters,
                          toast,
                          isWorkerView: props.isWorkerView,
                          setExpandedRows,
                          setIsExportDisabled: props.setIsExportDisabled,
                        });
                        setShowRejectPopup(false);
                        setHrComment("");
                      });
                    }}
                    disabled={isHRApproving || !hrComment.trim()}
                    className="tw-w-1/2 tw-py-3 tw-bg-[#00AFEE] tw-text-white tw-rounded-lg tw-font-semibold"
                    // className="tw-w-1/2 tw-py-3 tw-bg-red-500 tw-text-white tw-rounded-lg tw-font-semibold disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
                  />
                </div>
              </div>
            </Dialog>

            <Dialog
              header={`Time Log : ${timeLogDetails[0]?.displayName || ""} ( ${
                timeLogDetails[0]?.registration_no || ""
              } )`}
              visible={showTimeLogDetails}
              // draggable={false}
              style={{ width: "58vw" }}
              onHide={() => {
                if (!showTimeLogDetails) return;
                setShowTimeLogDetails(false);
                setSelectedProjectArray([]);
                setEditAppTimeRowIndices([]);
                setSelectedProject(null);
                setSelectedAppTimeDataArray([]);
                setShowTimeLogDetails(false);
                setEditProjectIndices([]);
                setIsSaveButtonDisabled(true);
                setIsManagerRejectView(false);
                setManagerTimeData({
                  manager_start: null,
                  manager_end: null,
                  manager_duration: null,
                });
              }}
            >
              <DataTable
                value={timeLogDetails}
                showGridlines
                scrollable
                scrollHeight="400px"
                rowGroupMode="rowspan"
                groupRowsBy="tracker_punch_in"
              >
                <Column
                  field="code"
                  header="Project Name"
                  className="!tw-w-[340px] !tw-max-w-[340px] !tw-min-w-[340px]"
                  body={(e) =>
                    projectNameBodyTemplate({
                      rowData: e,
                      editProjectIndices,
                      projectsList,
                      projectListLoading,
                      selectedProjectArray,
                      setSelectedProjectArray,
                      selectedProject,
                      setSelectedProject,
                    })
                  }
                ></Column>
                <Column
                  field="name"
                  header="Claimed Time"
                  className=""
                  body={(e) =>
                    appTimeLogBodyTemplate({
                      rowData: e,
                      isManagerRejectView,
                      editAppTimeRowIndices,
                      setEditAppTimeRowIndices,
                      selectedAppTimeDataArray,
                      setSelectedAppTimeDataArray,
                    })
                  }
                ></Column>
                {isManagerRejectView && (
                  <Column
                    field="tracker_punch_in"
                    header="Tracker Time"
                    className="tw-text-nowrap"
                    body={trackerTimeBodyTemplateViewOnly}
                  ></Column>
                )}
                <Column
                  field="category"
                  header="Description"
                  className="tw-w-[300px] tw-max-w-[300px] tw-min-w-[300px]"
                  body={descriptionBodyTemplate}
                ></Column>
                <Column
                  field="action"
                  header="Action"
                  body={actionBodyTemplate}
                ></Column>
              </DataTable>
              {isManagerRejectView && (
                <>
                  <div className="tw-mt-4 tw-p-4 tw-border tw-border-gray-300 tw-rounded">
                    <h4 className="tw-mb-3 tw-font-semibold">Manager Time</h4>
                    <div className="tw-flex tw-gap-4 tw-items-end">
                      <div className="tw-flex tw-flex-col">
                        <label className="tw-text-sm tw-mb-1">Start Time</label>
                        <Calendar
                          value={
                            managerTimeData.manager_start
                              ? new Date(managerTimeData.manager_start * 1000)
                              : null
                          }
                          onChange={(e) => {
                            if (e.value) {
                              const utcSelectedTime = new Date(
                                Date.UTC(
                                  new Date(
                                    timeLogDetails[0]?.log_date * 1000
                                  ).getUTCFullYear(),
                                  new Date(
                                    timeLogDetails[0]?.log_date * 1000
                                  ).getUTCMonth(),
                                  new Date(
                                    timeLogDetails[0]?.log_date * 1000
                                  ).getUTCDate(),
                                  e.value.getUTCHours(),
                                  e.value.getUTCMinutes(),
                                  0
                                )
                              );
                              const epochTime = Math.floor(
                                utcSelectedTime.getTime() / 1000
                              );
                              setManagerTimeData((prev: any) => {
                                const updated = {
                                  ...prev,
                                  manager_start: epochTime,
                                };
                                if (updated.manager_end) {
                                  const duration = calculateManagerDuration(
                                    epochTime,
                                    updated.manager_end
                                  );
                                  updated.manager_duration = duration;
                                }
                                return updated;
                              });
                            }
                          }}
                          timeOnly
                          hourFormat="24"
                          className="tw-border tw-border-solid tw-border-[#E2E2E2] tw-px-2 tw-py-[3px] tw-rounded"
                        />
                      </div>
                      <div className="tw-flex tw-flex-col">
                        <label className="tw-text-sm tw-mb-1">End Time</label>
                        <Calendar
                          value={
                            managerTimeData.manager_end
                              ? new Date(managerTimeData.manager_end * 1000)
                              : null
                          }
                          onChange={(e) => {
                            if (e.value) {
                              const utcSelectedTime = new Date(
                                Date.UTC(
                                  new Date(
                                    timeLogDetails[0]?.log_date * 1000
                                  ).getUTCFullYear(),
                                  new Date(
                                    timeLogDetails[0]?.log_date * 1000
                                  ).getUTCMonth(),
                                  new Date(
                                    timeLogDetails[0]?.log_date * 1000
                                  ).getUTCDate(),
                                  e.value.getUTCHours(),
                                  e.value.getUTCMinutes(),
                                  0
                                )
                              );
                              const epochTime = Math.floor(
                                utcSelectedTime.getTime() / 1000
                              );
                              setManagerTimeData((prev: any) => {
                                const updated = {
                                  ...prev,
                                  manager_end: epochTime,
                                };
                                if (updated.manager_start) {
                                  const duration = calculateManagerDuration(
                                    updated.manager_start,
                                    epochTime
                                  );
                                  updated.manager_duration = duration;
                                }
                                return updated;
                              });
                            }
                          }}
                          timeOnly
                          hourFormat="24"
                          className="tw-border tw-border-solid tw-border-[#E2E2E2] tw-px-2 tw-py-[3px] tw-rounded"
                        />
                      </div>
                      <div className="tw-flex tw-flex-col">
                        <label className="tw-text-sm tw-mb-1">Duration</label>
                        <InputText
                          value={managerTimeData.manager_duration || "00:00"}
                          className="tw-border tw-border-solid tw-border-[#E2E2E2] tw-px-2 tw-py-[3px] tw-rounded"
                          readOnly
                        />
                      </div>
                    </div>
                  </div>
                  <InputTextarea
                    value={managerComments}
                    onChange={(e) => {
                      setManagerComments(e.target.value);
                    }}
                    className="tw-w-full tw-mt-4"
                    rows={5}
                    cols={30}
                    placeholder="Add Comment"
                  />
                  <div className="tw-flex tw-items-center tw-mt-6 tw-text-base">
                    <input
                      type="checkbox"
                      id="hideComment"
                      className="tw-mr-2 tw-cursor-pointer tw-w-5 tw-h-4"
                      onChange={(e) => {
                        setHideManagerComments(e.target.checked);
                      }}
                    />
                    <label
                      htmlFor="hideComment"
                      className="tw-text-base tw-cursor-pointer tw-text-gray-700"
                    >
                      Hide comment from the user
                    </label>
                  </div>
                </>
              )}
              <div className="tw-flex tw-justify-end tw-gap-2 tw-mt-4">
                <Button
                  onClick={() => {
                    setIsManagerRejectView(false);
                    setShowTimeLogDetails(false);
                    setSelectedProjectArray([]);
                    setSelectedAppTimeDataArray([]);
                    setSelectedProject(null);
                    setShowTimeLogDetails(false);
                    setEditAppTimeRowIndices([]);
                    setEditProjectIndices([]);
                    setIsSaveButtonDisabled(true);
                    setManagerTimeData({
                      manager_start: null,
                      manager_end: null,
                      manager_duration: null,
                    });
                  }}
                  className="tw-rounded-lg tw-border tw-border-gray-300 tw-px-4 focus:tw-shadow-none hover:tw-bg-gray-200 tw-py-2 tw-font-medium tw-transition-all tw-duration-200"
                >
                  Cancel
                </Button>
                <Button
                  label={`${isManagerRejectView ? "Submit" : "Save"}`}
                  className="tw-bg-[#00AFEE] tw-text-white tw-py-2 tw-px-5 tw-rounded-lg"
                  disabled={
                    // (isManagerRejectView &&
                    //   selectedAppTimeDataArray.length === 0) ||
                    // (!isManagerApproveView && selectedProjectArray.length === 0)
                    isManagerRejectView
                      ? !managerTimeData.manager_duration
                      : isSaveButtonDisabled
                  }
                  onClick={(e) => {
                    // Add your save logic here
                    if (isManagerRejectView) {
                      handleRejectTimeLog(e);
                    } else {
                      handleUpdateProject(e);
                      setSelectedProjectArray([]);
                      setSelectedProject(null);
                      // setShowTimeLogDetails(false);
                      setSelectedAppTimeDataArray([]);
                      setEditAppTimeRowIndices([]);
                      setEditProjectIndices([]);
                    }
                    setSelectedProjectArray([]);
                    setSelectedAppTimeDataArray([]);
                    setSelectedProject(null);
                    setShowTimeLogDetails(false);
                    setEditAppTimeRowIndices([]);
                    setEditProjectIndices([]);
                    setIsManagerRejectView(false);
                    setIsSaveButtonDisabled(true);
                    // setIsManagerRejectView(false);
                  }}
                />
              </div>
            </Dialog>
          </div>
        )}
      </div>
    </>
  );
};

export default TeamLogs;
